var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#29c27e",
    fillRule: "evenodd",
    d: "M12.999,8.445v19.111 c0,1.901,1.544,3.445,3.445,3.445h25.111c1.901,0,3.445-1.544,3.445-3.445V8.445c0-1.901-1.544-3.445-3.445-3.445H16.445 C14.543,4.999,12.999,6.543,12.999,8.445z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#19ac66",
    d: "M2.999,45.501V17.445c0-1.901,1.544-3.445,3.445-3.445h6.559 l21.997,16.996v5.56c0,1.901-1.544,3.445-3.445,3.445H12.121L5.571,46.55c-0.273,0.279-0.653,0.451-1.072,0.451 C3.673,47.001,2.999,46.327,2.999,45.501z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c8045",
    d: "M12.999,27.555V13.999h18.556 c1.901,0,3.445,1.544,3.445,3.445v13.556H16.445C14.543,31.001,12.999,29.457,12.999,27.555z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleChat);
export default __webpack_public_path__ + "static/media/googleChat.396ff28e34af6286efb5d87bf1926ea0.svg";
export { ForwardRef as ReactComponent };